export enum ExclusionType {
	AirBnb = 1,
	ReservationType,
	HospitableDirectBooking = 3,
	vrbo = 4,
}

export interface IAirBnb {
	isExcluded: boolean;
	isSupported: boolean;
}

export interface IVrbo {
	isExcluded: boolean;
}

export interface IReservationType {
	text: string;
}

export interface IHospitableDirect {
	isExcluded: boolean;
	isSupported: boolean;
}

export class AirBnbSelected implements IAirBnb {
	readonly isExcluded: boolean;
	readonly isSupported: boolean;

	constructor() {
		this.isExcluded = true;
		this.isSupported = true;
	}
}

export class AirBnbUnSelected implements IAirBnb {
	readonly isExcluded: boolean;
	readonly isSupported: boolean;

	constructor() {
		this.isExcluded = false;
		this.isSupported = true;
	}
}

export class AirBnbNotSupported implements IAirBnb {
	readonly isExcluded: boolean;
	readonly isSupported: boolean;

	constructor() {
		this.isSupported = false;
		this.isExcluded = false;
	}
}

export class VrboSelected implements IVrbo {
	readonly isExcluded: boolean;
	readonly isSupported: boolean;

	constructor() {
		this.isExcluded = true;
		this.isSupported = true;
	}
}

export class VrboUnSelected implements IVrbo {
	readonly isExcluded: boolean;
	readonly isSupported: boolean;
	constructor() {
		this.isExcluded = false;
		this.isSupported = true;
	}
}

export class VrboNotSupported implements IVrbo {
	readonly isExcluded: boolean;
	readonly isSupported: boolean;

	constructor() {
		this.isSupported = false;
		this.isExcluded = false;
	}
}

export class AirBnb implements IAirBnb {
	isExcluded: boolean;
	isSupported: boolean;
}

export class Vrbo implements IVrbo {
	isExcluded: boolean;
	isSupported: boolean;
}

export class HospitableDirectSelected implements IHospitableDirect {
	readonly isExcluded: boolean;
	readonly isSupported: boolean;

	constructor() {
		this.isExcluded = true;
		this.isSupported = true;
	}
}

export class HospitableDirectUnSelected implements IHospitableDirect {
	readonly isExcluded: boolean;
	readonly isSupported: boolean;

	constructor() {
		this.isExcluded = false;
		this.isSupported = true;
	}
}

export class HospitableDirectNotSupported implements IHospitableDirect {
	readonly isExcluded: boolean;
	readonly isSupported: boolean;

	constructor() {
		this.isSupported = false;
		this.isExcluded = false;
	}
}

export class HospitableDirect implements IHospitableDirect {
	isExcluded: boolean;
	isSupported: boolean;
}

export class ReservationType implements IReservationType {
	text: string;
	readonly isSupported: boolean;

	constructor() {
		this.isSupported = true;
	}
}

export class Exclusion {
	airBnb: AirBnb;
	reservationType: ReservationType;
	hospitableDirect: HospitableDirect;
	vrbo: Vrbo;
}

export type Exclusions = AirBnbTypes;

export type HospitableDirectExclusion = HospitableDirectTypes;

export type AirBnbTypes = AirBnb | AirBnbSelected | AirBnbUnSelected | AirBnbNotSupported;

export type VrboTypes = Vrbo | VrboSelected | VrboUnSelected | VrboNotSupported;

export type HospitableDirectTypes = HospitableDirect | HospitableDirectSelected | HospitableDirectUnSelected | HospitableDirectNotSupported;

export type ExtractAirBnb<T> = T extends { isExcluded: boolean } ? T : AirBnbNotSupported;

export type ExtractHospitableDirect<T> = T extends { isExcluded: boolean } ? T : HospitableDirectNotSupported;

export type ExtractVrbo<T> = T extends { isExcluded: boolean } ? T : AirBnbNotSupported;

export type ExtractAirBnbSelected<T> = T extends { settingType: ExclusionType.AirBnb; isExcluded: true } ? AirBnbSelected : AirBnbUnSelected;

export type ExtractDirectSelected<T> = T extends { settingType: ExclusionType.HospitableDirectBooking; isExcluded: true } ? HospitableDirectSelected : HospitableDirectUnSelected;

export type ExtractVrboSelected<T> = T extends { settingType: ExclusionType.vrbo; isExcluded: true } ? VrboSelected : VrboUnSelected;

export type AirBnbOrNotSupported = ExtractAirBnb<Exclusions>;

export type VrboOrNotSupported = ExtractVrbo<VrboTypes>;

export type HospitableDirectOrNotSupported = ExtractHospitableDirect<HospitableDirectExclusion>;

export type AirBnbSelectedState = ExtractAirBnbSelected<AirBnbOrNotSupported>;

export type HospitableDirectSelectedState = ExtractDirectSelected<HospitableDirectOrNotSupported>;

export type VrboSelectedState = ExtractVrboSelected<VrboOrNotSupported>;
